/* istanbul ignore file */

import styled from 'styled-components'
import { AiUwCheckbox } from 'common-components'

export const Component = styled(AiUwCheckbox)`
  color: inherit !important;
`

export default (hoc) =>hoc(Component)
